import React from 'react';

const ImgRenderer = props => {
    console.log("imgprops", props)
    return React.createElement('img', { style: { height: "80%", width: "80%" }, alt: props.alt, src: props.src });
};

export default ImgRenderer;